export enum MessageInputVariant {
  STANDARD = "standard",
  OUTLINED = "outlined",
}
